import React from "react";
import PressReleaseSection from "../../components/Media/PressRelease.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
// import PartnerWithAptechSection from "../components/PartnerWithAptech/PartnerWithAptech.tsx";
const PressRelease = () => {
  return (
    <>
      <MetaComponent
        title="Press Release – Aptech Ltd."
        desc="Browse through the latest Press Release of Aptech, a leading skill-based training and development company in the world."
        keywords="Aptech press release, Aptech News and press release, Aptech shareholders."
      />
      <PressReleaseSection />
    </>
  );
};

export default PressRelease;
